import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source', 'feedback']

  async copy(event) {
    event.preventDefault()
    const text = this.readSource()
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
      this.flashFeedback()
    } catch (error) {
      console.error('clipboard.copy failed', error)
    }
  }

  readSource() {
    if (!this.hasSourceTarget) return ''
    const source = this.sourceTarget
    if (source.value !== undefined) return source.value
    return source.textContent.trim()
  }

  flashFeedback() {
    if (!this.hasFeedbackTarget) return

    const target = this.feedbackTarget
    if (this.originalText === undefined) {
      this.originalText = target.textContent
    }

    target.textContent = target.dataset.copiedLabel ||
      this.element.dataset.clipboardCopiedLabelValue ||
      'Copié'

    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => {
      target.textContent = this.originalText
    }, 1500)
  }
}
